import React, { useCallback, useMemo } from "react";

import * as Flags from "../../../../lib/Flags";
import * as SupportUtils from "../../../../lib/util/SupportUtils";
import * as HardwareUtils from "../../../../lib/util/HardwareUtils";
import MenuTrigger from "../../MenuTrigger/MenuTrigger";
import MenuDropdown, { MenuItem } from "../../MenuDropdown/MenuDropdown";
import Text from "../../../common/Text/Text";
import * as strings from "../../../../strings";
import { IconSupport } from "../../../../assets";
import * as UserActions from "../../../../store/User/User.action";
import { useLocation } from "../../../../lib/hook/NavigationHooks";
import { useDispatch } from "../../../../lib/hook/ReduxHooks";

const routes: Array<MenuItem & { disabledForHardware?: boolean }> = [
	{
		id: "contact",
		displayName: "%misc_contact_us",
		noRedirect: true,
		pathName: "#",
	},
	{
		displayName: "%navigation_faq",
		pathName: "#",
		noRedirect: true,
		id: "faq",
	},
	{
		displayName: "%navigation_privacy_policy",
		pathName: "/privacy",
		includeState: true,
		id: "privacy",
	},
	/*{
    displayName: "%navigation_user_guide",
    pathName: "/user-guide",
    noRedirect: false,
    id: "userGuide",
  },*/
	{
		displayName: "%navigation_reset_onboarding",
		pathName: "#",
		noRedirect: true,
		id: "resetOnboarding",
		disabledForHardware: true,
	},
	{
		displayName: "%navigation_anonymous_mode",
		pathName: "#",
		noRedirect: true,
		id: "anonymousMode",
		disabledForHardware: true,
	},
];

export interface NavSupportProps {
	onOpenChange?: (open: boolean) => void;
	onSelect: () => void;
	appType?: string;
}

const NavSupport = (props: NavSupportProps) => {
	const { onOpenChange, appType } = props;
	const dispatch = useDispatch();

	const handleSelect = useCallback(
		(item: any) => {
			if (item.id === "contact") {
				SupportUtils.contactSupport();
			} else if (item.id === "faq") {
				SupportUtils.openFAQ();
			} else if (item.id === "resetOnboarding") {
				dispatch(
					UserActions.updateUserOnboardingStep({
						step: {},
						reset: true,
					}),
				);
			} else if (item.id === "anonymousMode") {
				Flags.ANONYMOUS_MODE.toggle();
			}

			if (props.onSelect) {
				props.onSelect.call(null);
			}
		},
		[props.onSelect, dispatch],
	);

	const overlay = useMemo(
		() => ({
			tooltipReference: (
				<MenuTrigger>
					<Text inline={true}>{strings.NAVIGATION_SUPPORT}</Text>
				</MenuTrigger>
			),
		}),
		[],
	);

	const location = useLocation();
	const filteredRoutes = routes.filter(
		(route) =>
			!route.disabledForHardware ||
			!HardwareUtils.isSoftwareItemDisabled(appType),
	);

	return (
		<MenuDropdown
			referenceClassName={"Navigation__support"}
			onSelect={handleSelect}
			items={filteredRoutes}
			selected={location.pathname.includes("privacy") ? "privacy" : undefined}
			tooltipClassName={"Navigation__support-menu"}
			placement={"bottom-end"}
			onVisibleChange={onOpenChange}
			overlay={overlay}
		>
			<IconSupport className={"navigation-support"} />
		</MenuDropdown>
	);
};

export default NavSupport;
